<template>
  <div id="main" class="main" >
    <b-list-group v-if="selected == 'list'" style="margin-left: 10px; margin-right: 10px">
      <a :href="learnUrl" target="_blank" class="cursor-pointer"><img style="margin-top: -30px" id="login-img" src="../img/logo_1.png"/></a>
      <b-row v-if="tasks != null" align-h="between" style="margin-bottom: 10px" class="justify-content-center align-items-center">
        <b-col cols="2"><b-btn v-b-modal.modalCreateTask>Create task</b-btn></b-col>
      </b-row>
      <rise-loader color="rgb(39, 139, 172)" v-if="tasks == null"></rise-loader>
      <b-card v-if="tasks != null && tasks.length == 0" class="text-center">
        No connected tasks
      </b-card>
      <b-list-group-item variant="light" class="cursor-pointer" v-for="task in tasks" v-on:click="switchComponent('task', task)" button>
        <b-row>
          <b-col md="auto"><b-badge style="background-color:rgb(39, 139, 172)">{{task.timelineDate  | moment("YYYY-MM-DD")}}</b-badge></b-col>
          <b-col >{{task.headline}}</b-col>
        </b-row>
      </b-list-group-item>
    </b-list-group>
    <div v-if="selected == 'task'">
      <task v-bind:task=selectedTask v-bind:group=group v-bind:market=market v-bind:learnUrl=learnUrl @clicked="switchComponent('list')"></task>
    </div>
    <div class="hn-bg-city" style="left: -380px; position: fixed; top: 400px; z-index: -130;"></div>
    <div class="hn-bg-hill" style="height: 1642px; left: -690px; position: fixed; top: 508px; width: 1554px; z-index: -130;"></div>
    <div class="hn-bg-hill" style="height: 1650px; position: fixed; right: -1250px; top: 550px; width: 2560px; z-index: -120;"></div>
    <div class="hn-bg-bike" style="right: 60px; top: 514px; z-index: -90;"></div>
    <div class="hn-bg-bike" style="right: 100px; top: 516px; z-index: -90;"></div>
    <error-modal v-bind:text="errorText" v-bind:errorModalShow="errorModalShow"></error-modal>
    <create-task v-if='group'
                 v-bind:gradingScales=gradingScales
                 v-bind:groupId=group.groupId
                 v-bind:syllabusIds=group.syllabusIds
                 @getTaskPage="getTaskPage">
    </create-task>
  </div>
</template>

<script src="https://unpkg.com/@microsoft/teams-js@1.3.7/dist/MicrosoftTeams.min.js"></script>
<script>
import { RiseLoader } from 'vue-spinner/dist/vue-spinner.min.js'
import api from '../api'

import Task from './Task'
import ErrorModal from './ErrorModal'
import CreateTask from './CreateTask'

export default {
  components: {Task, RiseLoader, ErrorModal, CreateTask},
  name: 'Main',
  data () {
    return {
      tasks: null,
      group: null,
      unitId: null,
      gradingScales: [],
      market: null,
      selected: 'list',
      selectedTask: null,
      errorText: '',
      errorModalShow: false,
      learnUrl: ''
    }
  },
  created () {
    var vm = this
    microsoftTeams.initialize()
    microsoftTeams.authentication.authenticate({
      url: window.location.origin + '/simple-start',
      width: 600,
      height: 535,
      successCallback: function (result) {
        getUserInfo()
      },
      failureCallback: function (reason) {
        vm.showError(reason)
      }
    })

    function getUserInfo() {
      api.getUserInfo().then(response => {
        if (response.error) {
          showError(response.error)
          return
        }
        vm.group = response.groupData
        vm.market = response.market
        vm.unitId = response.unitId
        vm.learnUrl = response.learnUrl

        getTasks()
        getGradingScales(vm.unitId)
        setLanguage(vm.market)
      })
    }

    function getTasks() {
      api.getTasks().then(response => {
        if (response.error) {
          showError(response.error)
          return
        }
        vm.tasks = response.sort(function(a, b) {
          return new Date(b.timelineDate) - new Date(a.timelineDate)
        });
      })
    }

    function getGradingScales(unitId) {
      api.getGradingScales(unitId).then(response => {
        vm.gradingScales = response
      })
    }

    function showError(text) {
      vm.errorText = text
      vm.errorModalShow = true
    }

    function setLanguage(market) {
      if (vm.market == 'sweden') {
        vm.$i18n.locale = 'se'
      } else if (vm.market == 'norway') {
        vm.$i18n.locale = 'no'
      } else {
        vm.$i18n.locale = 'en'
      }

      import('../../lang/' + vm.$i18n.locale + '.json').then((msgs)=> {
        vm.$i18n.setLocaleMessage(vm.$i18n.locale, msgs.default || msgs)
      })
    }
  },

  methods: {
    switchComponent: function (comp, task) {
      this.selectedTask = task
      this.selected = comp
    },
    getTaskPage: function (selectedTask) {
      this.selectedTask = selectedTask
      this.selected = 'task'
    }
  }
}
</script>

<style scoped>
  #login-img {
    margin: 0 auto 10px;
    display: block;
    width: 185px;
  }

  .logo-image {
    background: url('../img/logo_1.png') 100% 100% no-repeat;
  }

  .hn-bg-bike {
    background: url('../img/bike.png') 100% 100% no-repeat;
    height: 40px;
    position: fixed;
    -ms-transform: rotate(-4deg);
    -moz-transform: rotate(-4deg);
    -webkit-transform: rotate(-4deg);
    transform: rotate(-4deg);
    width: 40px;
  }

  .hn-bg-city {
    background: url('../img/city.png') 100% 100% no-repeat;
    height: 219px;
    opacity: .8;
    width: 800px;
  }

  .hn-bg-hill {
    border-bottom-left-radius: 50%;
    border-bottom-right-radius: 50%;
    border-color: #F3F0E6;
    border-style: solid solid none;
    border-top-left-radius: 50%;
    border-top-right-radius: 50%;
    border-width: 8px 4px 0 0;
  }

  .cursor-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue